<!--
    描述：图表
    时间：2020-05-25
    Created by 张卫华
-->
<template>
    <div class="h100">
        <!-- 饼状图 -->
        <div>

        </div>

        <!-- 柱状图 -->
        <div>

        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        props : {},
        data() {
            return {

            }
        },
        computed: {},
        mounted() {},
        watch: {},
        created() {},
        methods: {
            initProjectChart(){ //参数

            },
        }
    }
</script>

<style scoped>

</style>